/** Adds the current query string to `path`. */
export const preserveUrlParams = (path: string): string => {
  const searchParams = new URLSearchParams(window.location.search).toString();
  return searchParams ? `${path}?${searchParams}` : path;
};

/** Returns the param value, or `null` if it is missing. */
export const getUrlParam = (name: string): string | null =>
  typeof window !== "undefined" ? new URLSearchParams(window.location.search).get(name) : null;

/** True only for `?qa_log=true`. */
export const hasQaLogParam = (): boolean => getUrlParam("qa_log") === "true";

/** Returns the `mos_cfg` value, or `null` if it is missing. */
export const getMosCfg = (): string | null => getUrlParam("mos_cfg");

/** True if `mos_cfg` is in the URL, even with an empty value. */
export const hasMosCfg = (): boolean => getMosCfg() !== null;

/** Returns the raw `thm` value, or `null` if it is missing. */
export const getThemeParam = (): string | null => getUrlParam("thm");

/** Sets `thm` in the URL and reloads the page. */
export const setThemeParam = (theme: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.set("thm", theme);
  window.location.assign(url.toString());
};

/** True if `webview_session` is in the URL. */
export const hasWebviewSessionParam = (): boolean => getUrlParam("webview_session") !== null;

/** Adds `webview_session` (current timestamp) to the URL without reloading. */
export const setWebviewSessionParam = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.set("webview_session", Date.now().toString());
  window.history.replaceState({}, "", url.toString());
};

/** Removes `webview_session` from the URL without reloading. */
export const removeWebviewSessionParam = (): void => {
  const params = new URLSearchParams(window.location.search);
  params.delete("webview_session");
  const query = params.toString();
  window.history.replaceState({}, "", window.location.pathname + (query ? `?${query}` : ""));
};
